import React, { forwardRef } from 'react';

import { useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import StatusVerifiedIcon from '@atlaskit/icon/core/status-verified';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import { i18n } from './messages';

const TooltipTagStyles = cssMap({
	wrapper: {
		display: 'flex',
	},
});

// A custom tag element to prevent a bug where an additional 1-pixel whitespace is rendered after the target element
export const TooltipTag = forwardRef<HTMLElement>((props, ref) => (
	<Box as="div" xcss={TooltipTagStyles.wrapper} ref={ref as React.Ref<HTMLDivElement>} {...props} />
));

export const Verified = () => {
	const { formatMessage } = useIntl();
	return (
		<Tooltip content={formatMessage(i18n.verifiedIconTooltipMessage)} tag={TooltipTag}>
			<StatusVerifiedIcon
				label={formatMessage(i18n.verifiedIconLabel)}
				color={token('color.icon.accent.blue')}
			/>
		</Tooltip>
	);
};
